import React, { useEffect, useState } from "react";

import {
  deleteRoomType,
  getRoomTypesList,
} from "../../../services/OrganisationServices/hostelRoomServices";
import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import { useParams } from "react-router-dom";
import { useGlobalState } from "../../../services/hostelConst.js";
import AddHostelRoomTypeForm from "./add-hostel-room-type";
const RoomTypesTable = () => {
  var { id } = useParams();
  console.log("the id here in the roomType: ", id);
  const { hostelMenuState, toggleHostelMenu, openModal, modalState } =
    useGlobalState();
  useEffect(() => {
    openModal({ ...modalState, hostelId: id });

    toggleHostelMenu(true);

    return () => {};
  }, []);

  return (
    <div>
      <MasterTable
        getTableData={getRoomTypesList}
        tab1={"Hostel"}
        tab2={"Room Types"}
        hostelId={id}
        AddForm={AddHostelRoomTypeForm}
        deleteRow={deleteRoomType}
        actions={{
          edit: true,
          delete: true,
        }}
      />
    </div>
  );
};

export default RoomTypesTable;
